export type CoaTemplateId = 'eg' | 'sa' | 'gcc' | 'generic';

export type TemplateAccount = {
  code: string;
  name: string;
  nameAr: string;
  type: 'asset' | 'liability' | 'equity' | 'revenue' | 'expense' | 'cogs';
};

export const COA_TEMPLATES: Record<CoaTemplateId, { label: string; accounts: TemplateAccount[] }> =
  {
    eg: {
      label: 'Egypt',
      accounts: [
        { code: '1000', name: 'Cash on hand', nameAr: 'النقدية', type: 'asset' },
        { code: '1100', name: 'Bank', nameAr: 'البنك', type: 'asset' },
        { code: '1200', name: 'Accounts receivable', nameAr: 'عملاء', type: 'asset' },
        { code: '1300', name: 'Inventory', nameAr: 'مخزون', type: 'asset' },
        { code: '2000', name: 'Accounts payable', nameAr: 'موردون', type: 'liability' },
        { code: '2100', name: 'VAT payable', nameAr: 'ضريبة قيمة مضافة مستحقة', type: 'liability' },
        { code: '3000', name: 'Owner equity', nameAr: 'حقوق الملكية', type: 'equity' },
        { code: '4000', name: 'Sales revenue', nameAr: 'إيرادات المبيعات', type: 'revenue' },
        { code: '5000', name: 'Cost of goods sold', nameAr: 'تكلفة المبيعات', type: 'cogs' },
        { code: '6000', name: 'Rent expense', nameAr: 'مصروف إيجار', type: 'expense' },
        { code: '6100', name: 'Salaries expense', nameAr: 'مصروف رواتب', type: 'expense' },
        { code: '6200', name: 'Utilities expense', nameAr: 'مرافق', type: 'expense' }
      ]
    },
    sa: {
      label: 'Saudi Arabia',
      accounts: [
        { code: '1000', name: 'Cash on hand', nameAr: 'النقدية', type: 'asset' },
        { code: '1100', name: 'Bank', nameAr: 'البنك', type: 'asset' },
        { code: '1200', name: 'Accounts receivable', nameAr: 'عملاء', type: 'asset' },
        { code: '1300', name: 'Inventory', nameAr: 'مخزون', type: 'asset' },
        { code: '2000', name: 'Accounts payable', nameAr: 'موردون', type: 'liability' },
        { code: '2100', name: 'VAT payable', nameAr: 'ضريبة القيمة المضافة', type: 'liability' },
        { code: '3000', name: 'Owner equity', nameAr: 'حقوق الملكية', type: 'equity' },
        { code: '4000', name: 'Sales revenue', nameAr: 'إيرادات المبيعات', type: 'revenue' },
        { code: '5000', name: 'Cost of goods sold', nameAr: 'تكلفة المبيعات', type: 'cogs' },
        { code: '6000', name: 'Rent expense', nameAr: 'مصروف إيجار', type: 'expense' },
        { code: '6100', name: 'Salaries expense', nameAr: 'مصروف رواتب', type: 'expense' },
        { code: '6200', name: 'GOSI expense', nameAr: 'التأمينات', type: 'expense' }
      ]
    },
    gcc: {
      label: 'GCC',
      accounts: [
        { code: '1000', name: 'Cash', nameAr: 'نقدية', type: 'asset' },
        { code: '1100', name: 'Bank', nameAr: 'بنك', type: 'asset' },
        { code: '2000', name: 'Payables', nameAr: 'دائنون', type: 'liability' },
        { code: '3000', name: 'Equity', nameAr: 'حقوق ملكية', type: 'equity' },
        { code: '4000', name: 'Revenue', nameAr: 'إيرادات', type: 'revenue' },
        { code: '5000', name: 'COGS', nameAr: 'تكلفة مبيعات', type: 'cogs' },
        { code: '6000', name: 'Operating expenses', nameAr: 'مصروفات تشغيل', type: 'expense' }
      ]
    },
    generic: {
      label: 'Generic',
      accounts: [
        { code: '1000', name: 'Cash', nameAr: 'نقدية', type: 'asset' },
        { code: '2000', name: 'Liabilities', nameAr: 'خصوم', type: 'liability' },
        { code: '3000', name: 'Equity', nameAr: 'حقوق ملكية', type: 'equity' },
        { code: '4000', name: 'Revenue', nameAr: 'إيرادات', type: 'revenue' },
        { code: '5000', name: 'Expenses', nameAr: 'مصروفات', type: 'expense' }
      ]
    }
  };
